import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, Switch, Route } from "react-router-dom";

import { bannerSlide, bannerLink } from "../data/home.js";
import portfolioList from "../data/portfolio.js";

import "../scss/main.scss";

function Home() {
  let [slideIndex, setSlideIndex] = useState(0);
  useEffect(() => {
    let slidePlay = setInterval(() => {
      if (slideIndex >= bannerSlide.length) {
        setSlideIndex(0);
      } else {
        setSlideIndex(slideIndex++);
      }
    }, 3000);
    return () => clearInterval(slidePlay);
  })

  const slideBall = () => {
    let slideBall = [];
    for (let i = 0; i < bannerSlide.length; i++) {
      slideBall.push(
        <span className={slideIndex === i ? "on" : ""} onClick={() => { setSlideIndex(i) }}></span>
      );
    }
    return slideBall;
  }

  let [tap, setTap] = useState(0);
  let tapName = ["All", "원페이지형", "표준형", "심화개발형", "쇼핑몰"];
  let list = [];
  let [more, setMore] = useState(12);
  for (let i = 1; i < tapName.length; i++){
    if (tap === 0) {
      list = [...portfolioList].slice(0, more);
    }else if(tap === i) {
      for (let j = 0; j < portfolioList.length; j++){
        if (portfolioList[j].type === tapName[i]) {
          list = [...list, portfolioList[j]].slice(0, 12);
        }
      }
    }
  }
  return (
    <>
      <div className="banner">
        <div className="flex">
          <ul className="slide">
            {
              bannerSlide.map((a, i) => {
                return (
                  <li key={i} className={slideIndex} style={slideIndex === i ? { opacity: 1, zIndex: 1 } : { opacity: 0, zIndex: 0 }}>
                    <div className="content">
                      <h2 dangerouslySetInnerHTML={{ __html: a.h2 }}></h2>
                      <p>풍부한 경험과 감각적인 디자인으로 <br />최상의 결과를 보장합니다</p>
                      <div className="ball">
                        {slideBall()}
                      </div>
                      <nav className="link">
                        <Link to="/portfolio/All">포트폴리오</Link>
                        <Link to="/about">회사소개서</Link>
                      </nav>
                    </div>
                    <img src={`/image/home/슬라이드이미지0${i + 1}.png`} alt="" />
                  </li>
                )
              })
            }
          </ul>

          <ul className="nav">
            {
              bannerLink.map((a, i) => {
                return (
                  <li key={i}>
                    <Link to={a.url}>
                      <img src={`image/home/${a.imageUrl}.png`} alt="" />
                      <p dangerouslySetInnerHTML={{ __html: a.p }}></p>
                      <img src="image/home/화살표.png" alt="" />
                    </Link>
                  </li>
                )
              })
            }
          </ul>
        </div>
      </div>

      <div className="about none">
        <div className="wrap">
          <div className="flex">
            <div className="content">
              <h2>
                코랜을 만나면 디자인이 <br />
                완전히 새로워집니다
              </h2>
              <p>
                풍부한 경험과 감각적인 디자인으로 <br />
                최상의 결과를 보장합니다.
              </p>
            </div>
            <img src="/image/home/사람들.png" alt="" />
          </div>
          
          <ul>
            <li>
              <img src="/image/home/따옴표.png" alt="" />
              <p>
                이름짓고, 홈페이지 만들고, <br />
                광고까지 한번에 다 해결되어서 <br />
                코랜과 함께하니 <br />
                참 편리한 것 같습니다.
              </p>
              <img src="/image/home/review01.png" alt="" />
            </li>
            <li>
              <img src="/image/home/따옴표.png" alt="" />
              <p>
                코랜에 홈페이지 맡겼다가 <br />
                블로그 광고도 의뢰했었는데, <br />
                코랜은 글을 참 잘쓰는 것 같습니다.<br />
                남다른 기획력으로 <br />
                많은 도움을 받았습니다.
              </p>
              <img src="/image/home/review02.png" alt="" />
            </li>
            <li>
              <img src="/image/home/따옴표.png" alt="" />
              <p>
                회사 홍보용 홈페이지가 필요해서 <br />
                알아보던 중 여기서 하게 되었는데요~<br />
                사이트 디자인도 깔끔하고, 반응형이라 <br />
                여러기기에서 잘 보여집니다.
              </p>
              <img src="/image/home/review03.png" alt="" />
            </li>
          </ul>
        </div>
      </div>

      <div className="svice">
        <div className="bg"><img src="/image/home/sviceBg.png" alt="" /></div>
        
        <div className="wrap">
          <h2>장사 잘되는 홈페이지, 코랜에 문의하세요.</h2>

          <ul>
            <li>
              <div className="icon"><img src="/image/home/svice01.png" alt="" /></div>
              <div className="content">
                <h3>반응형 홈페이지 제작</h3>
                <p>
                  다양한 사이즈의 화면이 사용되는 <br />
                  N스크린 시대에 반응형 웹사이트가 <br />
                  새로운 트랜드로 자리잡고 있습니다.
                </p>
              </div>
            </li>
            <li>
              <div className="icon"><img src="/image/home/svice02.png" alt="" /></div>
              <div className="content">
                <h3>쇼핑몰 제작</h3>
                <p>
                  국내/해외 온라인 쇼핑몰 제작부터<br />
                  마케팅까지! 글로벌 원스톱 서비스를<br />
                  제공합니다.
                </p>
              </div>
            </li>
            <li>
              <div className="icon"><img src="/image/home/svice03.png" alt="" /></div>
              <div className="content">
                <h3>홈페이지형 블로그 제작</h3>
                <p>
                  네이버 블로그 운영은 홈페이지로의<br />
                  유입량을 늘리기위한 강력한 수단중<br />
                  하나입니다.
                </p>
              </div>
            </li>
            <li>
              <div className="icon"><img src="/image/home/svice04.png" alt="" /></div>
              <div className="content">
                <h3>영상 제작</h3>
                <p>
                  홈피에 영상이 있으면, 회사소개 등을<br />
                  보다 효율적으로 할 수 있고, 비용은<br />
                  생각보다 저렴할 수 있습니다.
                </p>
              </div>
            </li>
            <li>
              <div className="icon"><img src="/image/home/svice05.png" alt="" /></div>
              <div className="content">
                <h3>브랜딩</h3>
                <p>
                  CI/BI, 브랜드 네이밍, 명함, 리플렛,<br />
                  카다로그 등 패키지 디자인 브랜드<br />
                  아이덴티티 구축
                </p>
              </div>
            </li>
            <li>
              <div className="icon"><img src="/image/home/svice06.png" alt="" /></div>
              <div className="content">
                <h3>마케팅</h3>
                <p>
                  온라인 프로모션, SNS마케팅, 디지털<br />
                  및 컨텐츠 마케팅 등 고객의 니즈와<br />
                  환경이 맞는 마케팅 전략 구축
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className="portfolio">
        <div className="wrap">
          <h2>PORTFOLIO</h2>
          <ul className="tap">
            <li className={tap === 0 ? "on" : ""} onClick={()=>{setTap(0)}}>All</li>
            <li className={tap === 1 ? "on" : ""} onClick={()=>{setTap(1)}}>원페이지형</li>
            <li className={tap === 2 ? "on" : ""} onClick={()=>{setTap(2)}}>표준형</li>
            <li className={tap === 3 ? "on" : ""} onClick={()=>{setTap(3)}}>심화개발형</li>
            <li className={tap === 4 ? "on" : ""} onClick={()=>{setTap(4)}}>쇼핑몰</li>
          </ul>

          <ul className="list">
            {
              list.map((a, i) => {
                return (
                  <li>
                    <a href={a.url} target="_blank">
                      <img src={`/image/portfolio/${a.imageUrl}.jpg`} alt="" />
                    </a>
                  </li>
                )
              })
            }
          </ul>

          {
            list.length < 12 
              ? null
              : <button onClick={() => { more > list.length ? setMore(12) : setMore(more + 4)}}>
              {
                more > list.length
                  ? "닫기" 
                  : "더보기"
              }
            </button>
          }
        </div>
      </div>

      <div className="skil">
        <div className="wrap">
          <ul>
            <li>
              <h2>홈페이지 제작 기술력</h2>
              <p>
                눈에 보이시는 것은 다 만들 수 있습니다. 모바일, 태블릿에서도 <br />
                최적화되는 것은 물론, 다른 곳에서 보셨던 모든 기능, 개발가능<br />
                합니다. 홈페이지 하나 기술적으로 잘 만들면, 다순 사무업무가<br />
                줄어들어, 인건비가 줄어듭니다.
              </p>
            </li>
            <li>
              <h2>예쁜 홈페이지</h2>
              <p>
                홈페이지가 예뻐야하는 것은 사람이 단정하고, 멋있고 예뻐야<br />
                상대방의 호감을 사는 것과 같은 이치입니다. 매우 아름다우면<br />
                가장 좋고, 비용상 그렇지 못하더라도 최소한 깔끔해야 고객의<br />
                호감을 살 수 있습니다.
               </p>
            </li>
            <li>
              <h2>유지보수도 척척</h2>
              <p>
                집도 다 짓고나서 쓰다보면 어디가 부서지고, 어디가 시원찮고<br />
                뭔가를 수정해야하고, 인테리어를 다시 해야할 때가 있습니다.<br />
                홈페이지 관리가 잘되먄, 고객 편의를 도모하여 고객문의가<br />
                늘어나 매출증대에 직간접적인 영향을 미칩니다.
               </p>
            </li>
            <li>
              <h2>검색최적화와 광고까지</h2>
              <p>
                잘 만들어놨는데, 어디 잘 보여야 홈페이지로써 제 역활을 다하는<br />
                것입니다. 누가 어떤 키워드를 검색해서 어떻게 들어왔는지를<br />
                분석하는 것은 홈페이지를 만드는 것 그 이상으로 중요합니다. 이<br />
                모든 것을 잘 해결하실 수 있도록 도와드리겠습니다.
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div className="youtbue">
        <iframe src="https://www.youtube.com/embed/ZdP1L3zA4o0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
      </div>
    </>
  );
}

export default Home;
